import { Button, Card, Col, Container, Row, } from "react-bootstrap";

import React from 'react'

const stylePaddingMarginReset = {
  padding: '0',
  mergin: '0',
}


const ProductCard = ({ title, description, image, link, button }) => {

  return (
    <Card className='rounded-0  border-0' style={{ color: 'black', minHeight: '100%' }}>
      <Card.Img className='rounded-0 card-img-center' variant="top" src={image} />
      <Card.Body className="text-center">
        <Card.Title>{title}</Card.Title>
        <Card.Text><span dangerouslySetInnerHTML={{ __html: description }} /></Card.Text>
        <Button variant="link" className="float-right text-sm text-secondary" href={link}>{button}</Button>
      </Card.Body>
    </Card>
  );
};



const ProductList = ({ products, title, description, button = 'dettagli' }) => {
  const numCols = Math.min(products.length, 6);
  return (
    <div style={{}}>
      <Row>
        <Col md={12} className="text-center"><h2>{title}</h2></Col>
      </Row>
      <Row>
        <Col style={{ padding: '5vh' }} md={12} className="text-center">
          <span dangerouslySetInnerHTML={{ __html: description }} />
        </Col>
      </Row>
      <Row className="justify-content-center">
        {products.map((product, index) => (
          <Col style={stylePaddingMarginReset} md={12 / numCols} key={index}>
            <ProductCard title={product.title} description={product.description} image={product.image} link={product.link} button={button} />
          </Col>
        ))}
      </Row>
    </div>

  );
};



export const Home = () => {
  const wineyard = [
    {
      title: "Vigneto Sialic",
      description: "<small class='text-secondary'>Bagnolo Piemonte</small>",
      image: "/images/vineyards/sialic.jpg",
      link: "/en/vineyards/sialic",
    },
    {
      title: "Vigneto Bram",
      description: "<small class='text-secondary'>Bagnolo Piemonte</small>",
      image: "/images/vineyards/bram.jpg",
      link: "/en/vineyards/bram",
    },
    {
      title: "Vigneto Brichet",
      description: "<small class='text-secondary'>Bagnolo Piemonte</small>",
      image: "/images/vineyards/brichet.jpg",
      link: "/en/vineyards/brichet",
    },
  ];

  const wines = [
    {
      title: "Sialic",
      description: "Sauvignon",
      image: "/images/wines/i sialic.png",
      link: "/en/wines/sialic",
    },
    {
      title: "Bram",
      description: "Pinot nero",
      image: "/images/wines/i bram.png",
      link: "/en/wines/bram",
    },
    {
      title: "Classici",
      description: "Da tradizione",
      image: "/images/wines/i classici.png",
      link: "/en/wines/brichet",
    },
  ];


  return (<>
   <Container>
      <Row style={{ paddingTop: '30vh', padding: '10vh' }}>
        <blockquote className="blockquote text-center">
          <h2>Welcome to Azienda Vitivinicola Agù</h2>
          <p className="mb-0">A family story that dates back to the 1980s, founded on a passion for wine, innovation, and the constant pursuit of the highest quality. Pioneers in our region, we introduced bottling and the quest for the DOC (Denomination of Controlled Origin) designation. Today, we continue this tradition of innovation, opening ourselves to international grape varieties and embracing heroic viticulture, with a fully terraced Sauvignon vineyard and a new Pinot vineyard located next to the historic "Brichet" vineyard.<br></br>Welcome to the world of Agù Winery, where tradition blends with innovation, the past intertwines with the future, and international grape varieties mix with local winemaking traditions to create expressive wines.</p>
        </blockquote>
        <Button variant="link" className="float-right text-sm text-secondary" href={"/en/history"}>Read our story</Button>
      </Row>
    </Container>
    <div style={{ backgroundColor: 'black', color: 'white', paddingTop: '5vh' }}>
      <ProductList
        products={wineyard}
        title="Our Vineyards: The Heart of the Winery"
        description="In our vineyards lies the beating heart of the Winery. Here, we firmly embrace the saying that <blockquote class='blockquote'><span className=' font-italic'>&quot;wine is made in the vineyard, not in the winery.&quot;</span></blockquote>"
        button="Enter the Vineyard" />
    </div>
    <div style={{ backgroundColor: 'black', color: 'white', paddingTop: '5vh' }}>
      <ProductList
        products={wines}
        title='Our Wines: Stories in Bottles of the Past, Present and Future'
        description="Each bottle tells a story of passion, dedication and quality, where the taste of the past blends with the enthusiasm for the future in every sip."
        button="Discover the Vintages" />
    </div>

  </>)
}
